import React, { useEffect } from 'react'
import { Dialog, IconButton, DialogTitle, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import '../../contactos/modalContacts.css'

import { useRules } from '../../../hooks/useRules'
import { Switchs } from '../../reusableUI/Switchs'

export const DialogListaValidator = ({ ruleId, open, setOpen, getRulesList }) => {

    const { validators, initLoadValidators, initUpdateEstatus } = useRules()

    useEffect(() => {
        initLoadValidators(ruleId)
    }, [initLoadValidators, ruleId])

    const handleChangeEstado = (e, id) => {

        const newData = {
            rule_id: ruleId,
            user_id: id,
            enabled: e.target.checked
        }

        initUpdateEstatus(newData, validators)
        getRulesList()
    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                Validadores
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>

            </DialogTitle>

            <DialogContent>
                <div className="table-responsive">
                    <table className="table p-table-global">
                        <thead className='p-thead-global'>
                            <tr className="text-center p-tr-titles-global">
                                <th className='text-start'>Nombre</th>
                                <th>Permiso para validar?</th>
                            </tr>
                        </thead>
                        <tbody>
                            {validators?.length > 0 && validators?.map(item => (
                                <tr key={item.id} className='p-tr-body-global' style={{ textTransform: 'capitalize' }}>
                                    <td className="text-start" style={{ textTransform: 'capitalize' }}>
                                        {item.nombre?.toLowerCase()}{' '}{item.apellidos?.toLowerCase()}
                                    </td>
                                    <td className="text-center">
                                        <Switchs
                                            checked={item.enabled}
                                            label={item.enabled ? "Habilitado" : 'Desactivado'}
                                            onChange={(e, id) => handleChangeEstado(e, item.id)}
                                        />
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            </DialogContent>

        </Dialog>
    )
}